import { useFeaturesStore } from '@/stores/features';
import { Button } from '@/components/atoms/Button';
import { BrandHomeLink } from '@/design-system/brand/BrandHomeLink';
import { useCurrentUser } from '@/stores/auth';

export const MaintenanceTakeover = () => {
  const on = useFeaturesStore((s) => s.flags.maintenance);
  const set = useFeaturesStore((s) => s.set);
  const user = useCurrentUser();
  if (!on) return null;
  return (
    <div className="maint-scrim" role="dialog" aria-modal="true">
      <div className="maint-card">
        <div className="maint-ic">
          <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
            <path d="M14.7 6.3a4 4 0 0 1-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 0 1 5.4-5.4l-2.5 2.5-2-2 2.5-2.5Z" />
          </svg>
        </div>
        <BrandHomeLink size={22} />
        <h1>
          Estamos em <span className="it">manutenção</span>
        </h1>
        <p>A loja está fora do ar por alguns minutos enquanto fazemos melhorias com cuidado.</p>
        <div className="maint-eta">
          <span className="maint-dot" /> Previsão de retorno em poucos minutos
        </div>
        {user?.role === 'admin' && <Button onClick={() => void set('maintenance', false)} className="maint-reopen">Reabrir plataforma</Button>}
      </div>
    </div>
  );
};
